































import EmailUs from '@/components/common/EmailUs.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    EmailUs,
  },
})
export default class Footer extends Vue {}
